export default __webpack_public_path__ + "static/media/Employee_Mobile.4bf1d8a8.svg";